import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";      // ✅ FIX
import App from "./App";   // ✅ FIX


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
